const styles = (theme) => ({
  root: {
    [theme.breakpoints.down('md')]: {
      display: 'block',
    },
  },
  content: {
    [theme.breakpoints.up('md')]: {
      paddingLeft: theme.spacing(4),
      paddingRight: theme.spacing(4),
    },
  },
});

export default styles;
